import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Tag } from '@components/tag';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { useToaster } from '@components/toaster';

import { useModel } from 'hooks/useModel';
import { useStore } from 'models/Provider';

import { AsanaSettings } from './Models';

export const AsanaSettingsPage = observer(() => {
  const { t, api } = useStore();
  const { showError, showSuccess } = useToaster();
  const model = useModel(AsanaSettings, {}, { api, showError, showSuccess, t });

  return (
    <Stack space={6}>
      <Stack space={2} orientation="horizontal">
        <Text font="heading2" text={t('integrations.asana.settings.header')} />
        {model.hasToken && (
          <Tag size="small" variant="green" text={t('integrations.asana.settings.header.token')} />
        )}
        {!model.hasToken && (
          <Tag
            size="small"
            variant="purple"
            text={t('integrations.asana.settings.header.notoken')}
          />
        )}
      </Stack>
      <Text text={t('integrations.asana.settings.instructions.header.sub')} />
      <Separator />
      <TextField label={t('integrations.asana.settings.token.label')} onChange={model.setToken} />
      <Stack space={0} orientation="horizontal" justify="flex-end">
        <Button
          isDisabled={model.token.length === 0}
          onClick={model.submitToken}
          text={t('integrations.asana.settings.submit')}
        />
      </Stack>
      <Separator />
      <Stack space={4}>
        <Text font="bold18" text={t('integrations.asana.settings.instructions.step1.header')} />
        <Stack space={2}>
          <Text
            font="bold16"
            text={t('integrations.asana.settings.instructions.step1.sub_header')}
          />
          <Text text={t('integrations.asana.settings.instructions.step1')} />
        </Stack>
        <Stack space={2}>
          <Text
            font="bold16"
            text={t('integrations.asana.settings.instructions.step2.sub_header')}
          />
          <Text text={t('integrations.asana.settings.instructions.step2.1')} />{' '}
          <a href="https://app.asana.com/0/developer-console" target="_blank">
            https://app.asana.com/0/developer-console
          </a>
          <Text text={t('integrations.asana.settings.instructions.step2.2')} />
          <Text text={t('integrations.asana.settings.instructions.step2.3')} />
        </Stack>
        <Stack space={2}>
          <Text
            font="bold16"
            text={t('integrations.asana.settings.instructions.step3.sub_header')}
          />
          <Text text={t('integrations.asana.settings.instructions.step3')} />
        </Stack>
      </Stack>
    </Stack>
  );
});
